<template>
   <div class="requestsReceived">
    <DataTable type="responce" title="我收到的需求" />
  </div>
</template>

<script>
import DataTable from "@/components/DataTable.vue";

export default {
components:{
    DataTable
}
}
</script>

<style>

</style>